import { ChangeDetectionStrategy, Component } from '@angular/core';

/**
 * Layout bit: vertical stack with consistent spacing. Used inside CADS components only.
 */
@Component({
  selector: 'cads-stack-bit',
  standalone: true,
  templateUrl: './cads-stack-bit.component.html',
  styleUrl: './cads-stack-bit.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CadsStackBitComponent {}
